import { BrnSeparator } from './lib/brn-separator';

export * from './lib/brn-separator';
export * from './lib/brn-separator.token';

export const BrnSeparatorImports = [BrnSeparator] as const;
